import { render, staticRenderFns } from "./Car.vue?vue&type=template&id=4bd3a587&scoped=true"
import script from "./Car.vue?vue&type=script&lang=js"
export * from "./Car.vue?vue&type=script&lang=js"
import style0 from "./Car.vue?vue&type=style&index=0&id=4bd3a587&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd3a587",
  null
  
)

export default component.exports